// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"styles_buttonsContainer__16_A4","title":"styles_title__2TBjP"};